import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { PharmacyProvider } from "@/contexts/PharmacyContext";
import HomePage from "@/pages/index";
import Login from "@/pages/login";
import Dashboard from "@/pages/dashboard";

import Approved from "@/pages/approved";
import TravelerReview from "@/pages/travelers/TravelerReview";

function App() {
  return (
    <AuthProvider>
      <PharmacyProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/approved" element={<Approved />} />
          <Route
            path="/travelers/:travelerId/:action"
            element={<TravelerReview />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </PharmacyProvider>
    </AuthProvider>
  );
}

export default App;
